import React, { useState, useEffect } from 'react'
import Button from 'components/button/Button'

export default function Verifier({
  colors,
  func,
  SFXS,
  PreviousSeedPair,
}: any) {
  const [anim, setanim] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setanim(false)
    }, 320)
  }, [anim])

  return (
    <div style={{ margin: '0 0 20px 0' }}>
      <Button
        customClass={
          PreviousSeedPair[0].Content === 'clients seed' ? 'disable' : ''
        }
        background={colors.secondary}
        textColor={colors.primary}
        SFX={SFXS.confirmSFX}
        anim={anim}
        func={func}
        width='100%'
        size='18px'
      >
        VERIFY
      </Button>
    </div>
  )
}
